import React from 'react';
import './preloader.sass';

export const Preloader = ({isVisible}) => {
  return isVisible ? (
    <div className='vv-preloader'>
      <div className='vv-preloader__loader'/>
      <div className='vv-preloader__backdrop'/>
    </div>
  ) : null;
};
